import {
  Box,
  createStyles,
  Divider,
  makeStyles,
  Typography,
} from '@material-ui/core';
import React from 'react';
import DistributionLineIcon from '../../../../static/outageIconsV2/distribution_line.svg';
import TransformerIcon from '../../../../static/outageIconsV2/transformer.svg';
import colors from '../../../../themes/main-colors';
import CottageIcon from '../icons/CottageIcon';
import { useTranslation } from '../../../../hooks/useTranslation';
import { NestedOutageStatusAccordion } from './NestedOutageStatusAccordion';

const useStyles = makeStyles(() =>
  createStyles({
    account: {
      fontSize: 18,
      fontWeight: 600,
    },
  }),
);

export function NestedOutage({ step }: { step: number }) {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <>
      <Box
        display={'flex'}
        flexDirection={'column'}
        gridGap={20}
        paddingY={3.75}
        paddingX={2.5}
      >
        <Typography variant="body2">
          {t('OUTAGES_AT_MULTIPLE_LOCATIONS_ACCOUNT')}
        </Typography>
        <Typography variant="body2" style={{ fontWeight: 600 }}>
          {t('WE_WILL_PROVIDE_RESTORATION_TIME')}
        </Typography>
      </Box>
      <Divider />
      <NestedOutageStatusAccordion
        location="28105 River Bank Ct, Oregon City, OR 97045"
        nestedOutageStatus={{
          estimatedRestoration: t('TO_BE_DETERMINED'),
          restorationStatus: t('CREW_ONSITE'),
          customersAffected: 10,
          outageIdentified: 'Oct 12, 12:01 a.m.',
          causeOfOutage: 'Downed power line',
        }}
        triggerContent={
          <Box display={'flex'} alignItems={'center'} gridGap={10}>
            <CottageIcon width={32} height={32} color={colors.roseRed} />
            <Box>
              <Typography variant="body2">Primary</Typography>
              <Typography variant="subtitle1" className={classes.account}>
                0163530000
              </Typography>
            </Box>
          </Box>
        }
      />
      <Divider />
      <NestedOutageStatusAccordion
        location="28105 River Bank Ct, Oregon City, OR 97045"
        nestedOutageStatus={{
          estimatedRestoration: t('TO_BE_DETERMINED'),
          restorationStatus: t('CREW_ONSITE'),
          customersAffected: 10,
          outageIdentified: 'Oct 12, 12:01 a.m.',
          causeOfOutage: 'Downed power line',
        }}
        triggerContent={
          <Box display={'flex'} alignItems={'center'} gridGap={10}>
            <TransformerIcon />
            <Typography variant="body2" style={{ fontWeight: 500 }}>
              {t('TRANSFORMER')}
            </Typography>
          </Box>
        }
      />
      <Divider />
      <NestedOutageStatusAccordion
        location="28105 River Bank Ct, Oregon City, OR 97045"
        nestedOutageStatus={{
          estimatedRestoration: t('TO_BE_DETERMINED'),
          restorationStatus: t('CREW_ONSITE'),
          customersAffected: 10,
          outageIdentified: 'Oct 12, 12:01 a.m.',
          causeOfOutage: 'Downed power line',
        }}
        triggerContent={
          <Box display={'flex'} alignItems={'center'} gridGap={10}>
            <DistributionLineIcon />
            <Typography variant="body2" style={{ fontWeight: 500 }}>
              {t('DISTRIBUTION_LINE')}
            </Typography>
          </Box>
        }
      />
    </>
  );
}
